import React from "react";
import { useNavigate } from "react-router-dom";
import { withResponsibleBridgeContext } from "./responsableBack.js";
import { goContextualBack } from "./contextualBack.js";

export default function OngletThoraciqueResponsable() {
  const navigate = useNavigate();

  const goBackToPreviousPage = () => {
    goContextualBack(navigate, "/portail-medecin");
  };

  const withCurrentBack = (path) => {
    return withResponsibleBridgeContext(path, { backMode: "current" });
  };

  const S = {
    container: {
      maxWidth: "900px",
      margin: "40px auto",
      padding: "24px",
      fontFamily: "Inter, sans-serif",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "12px",
      marginBottom: "18px",
      flexWrap: "wrap",
    },
    title: { fontSize: "32px", fontWeight: 800, margin: 0 },
    subtitle: { color: "#374151", marginTop: 8, marginBottom: 0 },
    grid: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr)",
      gap: "16px",
    },
    btn: {
      padding: "30px 20px",
      borderRadius: "14px",
      backgroundColor: "#1f2937",
      color: "#fff",
      fontSize: "22px",
      fontWeight: 700,
      cursor: "pointer",
      border: "none",
      boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
    },
    back: {
      marginTop: "24px",
      padding: "24px 36px",
      borderRadius: "14px",
      border: "1px solid #d1d5db",
      background: "#fff",
      color: "#111827",
      fontWeight: 700,
      fontSize: "24px",
      cursor: "pointer",
      boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
    },
  };

  return (
    <div style={S.container}>
      <div style={S.header}>
        <div>
          <h1 style={S.title}>🫁 Thoracique</h1>
          <p style={S.subtitle}>Gestion des astreintes thoraciques.</p>
        </div>
      </div>

      <div style={S.grid}>
        <button style={{ ...S.btn, backgroundColor: "#1f2937" }} onClick={() => navigate(withCurrentBack("/responsable/gardes?type=ASTREINTE_THORACIQUE"))}>
          🫁 Astreinte thoracique
        </button>
      </div>

      <button style={S.back} onClick={goBackToPreviousPage}>
        ⬅️ Retour à la page précédente
      </button>
    </div>
  );
}
